export class Step1 {
    
    public getspan1 = 'form.mapa_at.getspan1';
    public getidweb = 'form.mapa_at.getidweb';
    public getdatepublication = 'form.mapa_at.getdatepublication';
    public getpasavisinitial = 'form.mapa_at.getpasavisinitial';  
}
